import Tooltip from '@mui/material/Tooltip';
import VerifiedIcon from '@mui/icons-material/Verified';

// THE canonical author-role treatment, used everywhere a username is shown:
// curators get a soft teal "Team" chip, paying members the verified check.
// Renders inline after the name and brings its own left spacing.
export default function RoleBadges({ roles, className = '' }) {
  if (!roles) return null;
  const isTeam = roles.indexOf('team') !== -1;
  const isPaid = roles.indexOf('paid') !== -1;

  if (isTeam)
    return (
      <span
        className={`tw-ml-1.5 tw-inline-block tw-rounded-full tw-bg-primary-600/10 dark:tw-bg-primary-300/20 tw-px-2 tw-py-0.5 tw-align-[1px] tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-wide tw-text-primary-700 dark:tw-text-primary-300 ${className}`}
      >
        Team
      </span>
    );

  if (isPaid)
    return (
      <Tooltip title="Verified TravelFeed member">
        <VerifiedIcon
          className={`tw-ml-1 tw-align-[-3px] tw-text-primary-500 ${className}`}
          style={{ fontSize: '1.05rem' }}
        />
      </Tooltip>
    );

  return null;
}
